module.exports = __webpack_public_path__ + "a768e7de/img/placeholder.888fcd0b.svg";